import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  MenuItem,
  Box,
} from "@mui/material";


export default function CreateProductForm({ 
  open, 
  onClose, 
  onSubmit,
  onReset,
  name,
  pType,
  price,
  productTypes,
  message,
  setName,
  setPType,
  sellMethod,
  setSellMethod,
  quantityReference,
  setQuantityReference,
  unit,
  setUnit,
  handleReferenceChange,
  setPrice,
  empresaRubro,
}) {
  const isServicio = empresaRubro === "Servicios";

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {isServicio ? "Crear Nuevo Servicio" : "Crear Nuevo Producto"}
      </DialogTitle> 
      <DialogContent>
        <Box component="form" onSubmit={onSubmit} noValidate>
          <TextField
            margin="dense"
            label="Nombre"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{
              marginBottom: 2,
            }}
          />
          <TextField
            select
            margin="dense"
            label={isServicio ? "Tipo de servicio" : "Tipo de producto"}
            fullWidth
            value={pType}
            onChange={(e) => setPType(e.target.value)}
            sx={{ marginBottom: 2 }}
          >
            {productTypes.map((type) => (
              <MenuItem key={type.id} value={type.id}>
                {type.type}
              </MenuItem>
            ))}
          </TextField>

          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <Typography variant="body2" sx={{ mr: 1 }}>Venta por</Typography>
            <TextField
              select
              value={sellMethod}
              onChange={(e) => setSellMethod(e.target.value)}
              sx={{ flexGrow: 1 }}
            >
              <MenuItem value="Unidad">Unidad</MenuItem>
              <MenuItem value="Decimal">Decimal</MenuItem>
            </TextField>

            {sellMethod === "Decimal" && (
              <Box sx={{ display: "flex", alignItems: "center", ml: 2 }}>
                <TextField
                  label="Referencia"
                  type="number"
                  value={unit === "kg" ? quantityReference / 1000 : quantityReference}
                  onChange={handleReferenceChange}
                  sx={{ flexGrow: 1, mr: 1 }}
                />
                <TextField
                  select
                  value={unit}
                  onChange={(e) => setUnit(e.target.value)}
                  label="Unidad"
                  sx={{ width: 100 }}
                >
                  <MenuItem value="gr">gr</MenuItem>
                  <MenuItem value="kg">kg</MenuItem>
                </TextField>
              </Box>
            )}
          </Box>

          <TextField
            margin="dense"
            label={
              sellMethod === "Unidad"
                ? "Precio por unidad"
                : `Precio por ${quantityReference || "___"} gr`
            }
            type="number"
            fullWidth
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            sx={{
              marginBottom: 2,
            }}
          />
          {message && (
            <Typography color="error" sx={{ mt: 1 }}>
              {message}
            </Typography>
          )}
          <DialogActions sx={{ justifyContent: "space-between", mt: 2 }}>
            <Button onClick={onReset} color="secondary">
              Restablecer
            </Button>
            <Box>
              <Button onClick={onClose} color="primary">
                Cerrar
              </Button>
              <Button
                type="submit"
                color="primary"
                variant="contained"
                sx={{ ml: 1 }}
              >
                Confirmar
              </Button>
            </Box>
          </DialogActions>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
